import { z } from 'zod';

// Schema for bulk eAlert form
export const bulkEAlertSchema = z.object({
  organization_id: z.string().trim().min(1, 'Organization ID is required'),
  tag: z.string().trim().min(1, 'Tag is required'),
  interval: z.enum(['daily', 'weekly', 'bi-weekly']),
  ignore_tag_filter: z.boolean().optional(),
  // Location parameters (optional)
  city: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  // Multi-city array — sent alongside `city` so backend can adopt the
  // array shape later. `city` stays as a comma-joined fallback for the
  // current substring-match SQL.
  cities: z.array(z.string()).optional(),
  state: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  subdivision: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  // Search parameters (optional)
  q: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  // Property specifications (optional)
  bedrooms: z
    .union([z.number().int().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseInt(val, 10) : val)),
  bathrooms: z
    .union([z.number().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseFloat(val) : val)),
  min_price: z
    .union([z.number().int().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseInt(val, 10) : val)),
  max_price: z
    .union([z.number().int().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseInt(val, 10) : val)),
  property_type: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  propertysubtype: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  status: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  // Boolean features (optional)
  waterfront: z.boolean().optional(),
  pool: z.boolean().optional(),
  basement: z.boolean().optional(),
  garage: z.boolean().optional(),
  city_view: z.boolean().optional(),
  mountain_view: z.boolean().optional(),
  park_view: z.boolean().optional(),
  water_view: z.boolean().optional(),
  // Square footage (optional)
  sqft_min: z
    .union([z.number().int().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseInt(val, 10) : val)),
  sqft_max: z
    .union([z.number().int().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseInt(val, 10) : val)),
});

// Type for bulk eAlert form data
export type BulkEAlertFormData = z.infer<typeof bulkEAlertSchema>;
